import { ChangeEvent, FC, useEffect } from 'react';

import { useFormikContext } from 'formik';
import { Button } from 'ui/components/common';
import OtpForm from 'ui/components/form/OTP/OTPForm';
import { OTP_LENGTH } from 'utils/constants';

import { useLoginContext } from '../containers/login/Login';
import { LOGIN_VERIFICATION_FORM } from './schema';

interface PROPS {
  error?: boolean;
  disabled?: boolean;
  onResendOtp: () => void;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
}

const LoginNominationVerifyForm: FC<PROPS> = ({
  onChange,
  error,
  disabled,
  onResendOtp,
}) => {
  const { values, handleSubmit } = useFormikContext<LOGIN_VERIFICATION_FORM>();
  const { setMethod } = useLoginContext();

  useEffect(() => {
    if (OTP_LENGTH === values?.otp.length) {
      setTimeout(handleSubmit, 2000);
    }
  }, [values, handleSubmit]);

  return (
    <OtpForm
      onSubmit={handleSubmit}
      onChange={onChange}
      onResendOtp={onResendOtp}
      disabled={disabled}
      value={values.otp}
      error={!!error}
    >
      {(otpForm) => (
        <div className="flex flex-col items-center">
          <Button
            label="Resend Code"
            disabled={otpForm?.disabled}
            onClick={otpForm?.resendOtp}
            intent="link"
            className="text-content"
          />
          <Button
            label="Try Another Way"
            disabled={disabled}
            onClick={() => setMethod(null)}
            intent="link"
          />
        </div>
      )}
    </OtpForm>
  );
};

export default LoginNominationVerifyForm;
